export default class AbaRelacionada {
  constructor () {
    this.abasRelacionadas = [
      {
        nome: 'DADOS CADASTRAIS',
        codigo: 'DADOS_CADASTRAIS'
      },
      {
        nome: 'MANDATOS',
        codigo: 'MANDATOS'
      },
      {
        nome: 'ÁREA DE AÇÃO',
        codigo: 'AREA_ACAO'
      },
      {
        nome: 'ANS',
        codigo: 'ANS'
      },
      {
        nome: 'CERTIFICAÇÕES',
        codigo: 'CERTIFICACOES'
      }
    ]
  }
  getAbaRelacionada () {
    return this.abasRelacionadas
  }
}
